import * as Constants from '@/constants';
import * as moment from 'moment';
import utilityFunctions from '@/utils/functions';
/* eslint-disable */

export default class {
  constructor(data, fromEdit, fromCopy) {
    const sessionEnd = data.sessionEnd ? data.sessionEnd.split('T')[1] : null;
    this.medicaid = [{ minutes: '', procedureId: '', procedureName: '' }];
    this.totalMedicaidMinutes = 0;
    this.totalReimbursableMinutes = data.medicaidMinutes || 0;
    if (data.medicaidSessions.length) {
      if (!fromEdit) {
        let o;
        this.medicaid = data.medicaidSessions.map((medicaid) => {
          // exclude values preventing copying the SL
          const { id, referenceId, referenceType, ...obj } = medicaid;
          if (obj && obj.objectives && obj.objectives.length) {
            o = obj.objectives.map((proc) => {
              // exclude values preventing copying the SL
              // eslint-disable-next-line no-shadow
              const { id, medicaidSessionId, ...m } = proc;
              return m;
            });
          }
          obj.objectives = o;
          return obj;
        });
      } else {
        this.medicaid = data.medicaidSessions;
      }
      data.medicaidSessions.forEach((m) => {
        this.totalMedicaidMinutes += m.minutes;
      });
    }
    this.serviceInformation = {
      serviceStartDate: moment(data.serviceStartDate, 'YYYY-MM-DD').format('MM-DD-YYYY'),
      serviceEndDate: moment(data.serviceEndDate, 'YYYY-MM-DD').format('MM-DD-YYYY'),
      fullName: fromEdit ? `${data.providerFirstName} ${data.providerLastName}` : data.providerFullName,
      providerFirstLastName: `${data.providerFirstName} ${data.providerLastName}`,
      credentialName: data.providerCredential,
      credentialType: data.providerCredentialType,
      absentType: data.absentType,
      absentReason: data.absentReason,
      absentAlternative: data.absentAlternative,
      absentAlternativeDesc: data.absentAlternativeDesc,
      noServiceNotifFlag: data.noServiceNotifFlag,
      groupSize: data.groupType === Constants.INDIVIDUAL ? 1 : data.groupSize,
      groupType: data.groupType,
      sessionDate:
        data.sessionDate ? utilityFunctions.formatDate(data.sessionDate) : null,
      militaryStartTime: data.sessionTime,
      militaryEndTime: sessionEnd,
      sessionTime: data.sessionTime || null,
      sessionTimeEnd: sessionEnd || null,
      sessionMinutes: data.sessionMinutes,
      location: data.location,
      locationOther: data.locationOther,
      deliveryMode: data.deliveryMode ? data.deliveryMode.toUpperCase() : null,
      serviceDelivered: data.serviceDelivered,
      roomName: data.roomName,
      progressAssessment: data.progressAssessment,
      studentBehavior: data.studentBehavior,
      nextSessionFocus: data.nextSessionFocus,
      sessionFocusValidate: data.nextSessionFocus && data.nextSessionFocus.length > 300 ? false : true,
      nextSessionGoal: data.nextSessionGoal,
      sessionGoalValidate: data.nextSessionGoal && data.nextSessionGoal.length > 300 ? false : true,
      sessionNotes: data.sessionNotes,
      objectiveNotes: data.objectiveNotes,
      providerLocation: data.providerLocation,
      notes: data.notes,
      licenseAttestUserId: data.licenseAttestUserId,
      licenseAttestName: data.licenseAttestName,
      licenseAttestDate: data.licenseAttestDate,
      supervisorUserId: data.supervisorUserId,
      supervisorName: data.supervisorName,
      supervisorCredential: data.supervisorCredential,
      supervisorDate: data.supervisorDate,
      serviceDocumentation: '',
      ptSessionBehaviors: data.ptSessionBehaviors,
      ptSessionObjectives: data.ptSessionObjectives,
      ptSessionProgresses: data.ptSessionProgresses,
      ptSessionObjectiveImplementation: fromEdit || fromCopy
        ? data.ptSessionObjectives.map((objective) => {
        const objectiveId = objective.id;
        return data.ptSessionObjectiveImplementation.map((x) => {
          return {
            id: x[0].id,
            name: x[0].implementation,
            value: x[0].implementation_code,
            objectiveId: x[0].pt_session_objective_id
          }
        }).filter((implementation) => {
          return implementation.objectiveId === objectiveId;
        });
      })
        : data.ptSessionObjectiveImplementation
    };
    let index = 0;
    this.serviceInformation.ptSessionProgresses.forEach(progressCode => {
      if (data.ptSessionProgressMeasures && data.ptSessionProgressMeasures.length !== 0) {
        const matchingMeasures = data.ptSessionProgressMeasures.filter(measure => measure.ptSessionTaskId === progressCode.id);
        progressCode.measurable = matchingMeasures;
      }
      else {
        this.serviceInformation.ptSessionProgresses[index].measurable = [{
          ptSessionTaskId: this.serviceInformation.ptSessionProgresses[index].id,
          type: 'OUT_OF',
          value1: '',
          value2: ''
        },
        {
          ptSessionTaskId: this.serviceInformation.ptSessionProgresses[index].id,
          type: 'MINUTES',
          value1: ''
        },
        {
          ptSessionTaskId: this.serviceInformation.ptSessionProgresses[index].id,
          type: 'ACCURACY',
          value1: ''
        }]
      }
      if (data.ptSessionProgressAssistance && data.ptSessionProgressAssistance.length !== 0) {
        const matchingAssistance = data.ptSessionProgressAssistance.filter(assistance => assistance.ptSessionTaskId === progressCode.id);
        progressCode.assistance = matchingAssistance;
      }
      else {
        this.serviceInformation.ptSessionProgresses[index].assistance = [{
          ptSessionTaskId: this.serviceInformation.ptSessionProgresses[index].id,
          type: 'OUT_OF',
          value1: '',
          value2: ''
        },
        {
          ptSessionTaskId: this.serviceInformation.ptSessionProgresses[index].id,
          type: 'MINUTES',
          value1: ''
        },
        {
          ptSessionTaskId: this.serviceInformation.ptSessionProgresses[index].id,
          type: 'PERCENT',
          value1: ''
        },
        {
          ptSessionTaskId: this.serviceInformation.ptSessionProgresses[index].id,
          type: 'NONE',
          value1: ''
        }]
      }
      if (data.ptSessionProgressTypes && data.ptSessionProgressTypes.length !== 0) {
        const matchingTypes = data.ptSessionProgressTypes.filter(type => type.ptSessionTaskId === progressCode.id);
        progressCode.type = matchingTypes;
      }
      else {
        this.serviceInformation.ptSessionProgresses[index].type = [{
          ptSessionTaskId: null,
          id: null,
          code: 'PEER',
          assistType: 'Peer',
          checked: false
        },
        {
          ptSessionTaskId: null,
          id: null,
          code: 'ADULT',
          assistType: 'Adult',
          checked: false
        },
        {
          ptSessionTaskId: null,
          id: null,
          code: 'REMINDERS',
          assistType: 'Reminders',
          checked: false
        },
        {
          ptSessionTaskId: null,
          id: null,
          code: 'OTHER',
          assistType: '',
          checked: false
        },
      ];
    }
    index++;
  });

    // if ((fromEdit || fromCopy) && this.serviceInformation) {
    //   this.serviceInformation.ptSessionProgresses.forEach(progressCode => {
    //     let types = {};

    //     progressCode.type.forEach(typeItem => {
    //       let progressType = typeItem.code;

    //       if (progressType === 'ADULT' || progressType === 'PEER' || progressType === 'REMINDERS' || progressType === 'OTHER') {
    //         types[progressType] = true;
    //       }

    //       if (progressType === 'OTHER') {
    //         types['assistType'] = typeItem.assistType;
    //       }
    //     });

    //     progressCode.type = types;
    //   });
    // }

    if (this.serviceInformation.ptSessionProgresses.length === 0) {
      this.serviceInformation.ptSessionProgresses = [{
        id: null,
        task: '',
        measurable: [{
          ptSessionTaskId: null,
          type: 'OUT_OF',
          value1: '',
          value2: ''
        },
        {
          ptSessionTaskId: null,
          type: 'MINUTES',
          value1: ''
        },
        {
          ptSessionTaskId: null,
          type: 'ACCURACY',
          value1: ''
        }],
        assistance: [{
          ptSessionTaskId: null,
          type: 'OUT_OF',
          value1: '',
          value2: ''
        },
        {
          ptSessionTaskId: null,
          type: 'MINUTES',
          value1: ''
        },
        {
          ptSessionTaskId: null,
          type: 'PERCENT',
          value1: ''
        },
        {
          ptSessionTaskId: null,
          type: 'NONE',
          value1: ''
        }],
        type: [{
          ptSessionTaskId: null,
          id: null,
          code: 'PEER',
          assistType: 'Peer',
          checked: false
        },
        {
          ptSessionTaskId: null,
          id: null,
          code: 'ADULT',
          assistType: 'Adult',
          checked: false
        },
        {
          ptSessionTaskId: null,
          id: null,
          code: 'REMINDERS',
          assistType: 'Reminders',
          checked: false
        },
        {
          ptSessionTaskId: null,
          id: null,
          code: 'OTHER',
          assistType: '',
          checked: false
        },
      ]
      }];
    }

    this.serviceInformation.ptSessionProgresses.forEach(progressCode => {
      progressCode.assistance.forEach(assistance => {
        if(assistance.type === "NONE" && assistance.value1 === "none") {
          assistance.value1 = true;
        }
        if(assistance.type === "NONE" && assistance.value1 === "false") {
          assistance.value1 = '';
        }	
        if(assistance.value1 === null) {	
          assistance.value1 = '';	
        }	
        if(assistance.value2 === null) {	
          assistance.value2 = '';	
        }	
        if (fromCopy) {
          assistance.id = null;
          assistance.ptSessionTaskId = null;
        }
      });	
    });	
    this.serviceInformation.ptSessionProgresses.forEach(progressCode => {	
      progressCode.measurable.forEach(measure => {	
        if(measure.value1 === null) {	
          measure.value1 = '';	
        }	
        if(measure.value2 === null) {	
          measure.value2 = '';
        }
        if (fromCopy) {
          measure.id = null;
          measure.ptSessionTaskId = null;
        }
      });
    });

    this.serviceInformation.ptSessionProgresses.forEach(progressCode => {
      progressCode.type.forEach(type => {
        if(type.code && (fromEdit || fromCopy)) {
          if(type.assistType == null && type.code === "PEER") type.assistType = "Peer";
          else if(type.assistType == null && type.code === "ADULT") type.assistType = "Adult";
          else if(type.assistType == null && type.code === "REMINDERS") type.assistType = "Reminders";
          else if(type.assistType == null && type.code === "OTHER") type.assistType = "";
        }
        if (fromCopy) {
          this.serviceInformation.sessionDate = '';
          type.id = null;
          type.ptSessionTaskId = null;
        }
        if (type.checked === 'true') type.checked = true;
        if (type.checked === 'false') type.checked = false;
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/utils/service-log-class.js